export default "__VITE_ASSET__dHtMGFxv__"